module.exports = __webpack_public_path__ + "05_glasses_red.448ab3d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/05_glasses_red.png
// module id = +RjI
// module chunks = 0